import { render, staticRenderFns } from "./imitate_aspiration.vue?vue&type=template&id=84b590b0&scoped=true"
import script from "./imitate_aspiration.vue?vue&type=script&lang=js"
export * from "./imitate_aspiration.vue?vue&type=script&lang=js"
import style0 from "./imitate_aspiration.vue?vue&type=style&index=0&id=84b590b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b590b0",
  null
  
)

export default component.exports